import { useEffect } from "react";
import { useSearchParams } from "react-router";

/**
 * Lê um parâmetro da URL uma vez (`?abrir=<id>`, `?aba=insumos`) e tira ele da URL — senão
 * recarregar a página ou voltar nela abriria o item de novo. Usado pela busca global pra cair
 * direto no item, não só na tela.
 */
export function useParametroDaUrl(nome: string, aoLer: (valor: string) => void) {
  const [params, setParams] = useSearchParams();
  const valor = params.get(nome);
  useEffect(() => {
    if (!valor) return;
    aoLer(valor);
    setParams(
      (p) => {
        p.delete(nome);
        return p;
      },
      { replace: true },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valor]);
}
